import React from "react";

import { AudioTestState } from "../../../types/Device.types";
import { ConnectedAudioTestActive } from "../audio-test-active/ConnectedAudioTestActive";
import { ConnectedAudioTestEndedFeedback } from "../audio-test-ended-feedback/ConnectedAudioTestEndedFeedback";
import { ConnectedAudioTestEndedWorking } from "../audio-test-ended-working/ConnectedAudioTestEndedWorking";
import { ConnectedAudioTestEndedIssue } from "../audio-test-ended-issue/ConnectedAudioTestEndedIssue";

import { AudioTestViewProps } from "./AudioTestView.types";

export const AudioTestView: React.FC<AudioTestViewProps> = ({ testState }) => {
  // Render the Audio test active state if the test is initiated or in progress

  if (testState === AudioTestState.RESULT_CLARITY) {
    return <ConnectedAudioTestEndedFeedback />;
  } else if (testState === AudioTestState.RESULT_FINISH_PROMPT) {
    return <ConnectedAudioTestEndedWorking />;
  } else if (testState === AudioTestState.TEST_UNCLEAR) {
    return <ConnectedAudioTestEndedIssue />;
  } else {
    return <ConnectedAudioTestActive />;
  }
};
